module.exports = __webpack_public_path__ + "img/option-2.7040c455.png";